module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-region="invoice-container"></div><div data-region="invoice-create"></div>';
}
return __p;
};
